import { reactive } from "vue";
import Validators from '@/utils/_validators';

const errors = reactive({});

export default function FormValidation() {
    const { isEmpty, minLength, isEmail, isNum } = Validators();

    const validateTextField = (fieldName, fieldValue, len=3) => {
        errors[fieldName] = isEmpty(fieldName, fieldValue) || minLength(fieldName, fieldValue, len)
    }

    const validateEmailField = (fieldName, fieldValue) => {
        errors[fieldName] = isEmpty(fieldName, fieldValue) || isEmail(fieldName, fieldValue)
    }

    const validatePhoneField = (fieldName, fieldValue, len=10) => {
        // errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) : isNum(fieldName, fieldValue)
        errors[fieldName] = isEmpty(fieldName, fieldValue) || isNum(fieldName, fieldValue) || minLength(fieldName, fieldValue, len)
        return errors[fieldName];
    }

    const validatePasswordField = (fieldName, fieldValue, len=6) => {
        errors[fieldName] = isEmpty(fieldName, fieldValue) || minLength(fieldName, fieldValue, len)
    }

    const validateCaptcha = (fieldName, fieldValue) => {
        errors[fieldName] = isEmpty(fieldName, fieldValue)
    }

    return {
        errors,
        validateTextField,
        validateEmailField,
        validatePhoneField,
        validatePasswordField,
        validateCaptcha
    };
}